<!-- <input [(ngModel)]="value" matInput [matDatepicker]="picker" />
 <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
<mat-datepicker #picker (closed)="closed($event)"></mat-datepicker> -->
<div class="ag-custom-component-popup ag-input-text-wrapper">
    <mat-form-field appearance="fill">
        <input [(ngModel)]="value" matInput [matDatepicker]="picker" (focus)="picker.open()" (click)="picker.close()">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker (closed)="closed($event)"></mat-datepicker>
    </mat-form-field>
</div>